<template>
	<v-card>
		<v-card-text class="pa-0">
			<v-data-table
				:headers="headers"
				:items="categories"
				:items-per-page="-1"
				no-data-text="Non c'è ancora nessuna categoria, creane subito una!"
				group-by="reference"
				item-key="id"
			>
				<template v-slot:top>
					<v-toolbar flat>
						<v-toolbar-title>
							<h2 class="primary--text">Categorie</h2>
						</v-toolbar-title>
					</v-toolbar>
					<v-divider />
				</template>

				<template v-slot:group.header="{ group, headers }">
					<td :colspan="headers.length" class="font-weight-bold text-center">
						{{
							group
								.split(' ')
								.map((el) => el.charAt(0).toUpperCase() + el.slice(1))
								.join(' ')
						}}
					</td>
				</template>

				<template v-slot:item.title="{ item }">
					<span class="font-weight-bold">{{ item.title }}</span>
				</template>

				<template v-slot:item.actions="{ item }">
					<v-btn small color="primary" @click="openEditDialog(item)">
						Modifica
					</v-btn>
				</template>
			</v-data-table>
		</v-card-text>

		<categorie-edit-form
			:categories="categories"
			:editDialog="edit.dialog"
			:editItem="edit.item"
			:closeEdit="closeEditDialog"
			:removeDialog="remove.dialog"
			:openRemove="openRemoveDialog"
			:closeRemove="closeRemoveDialog"
		/>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import CategorieEditForm from './EditForm'

export default {
	name: 'CategorieIndexTable',
	components: {
		CategorieEditForm,
	},

	data() {
		return {
			headers: [
				{ text: 'Titolo', value: 'title', width: '15%' },
				{ text: 'Descrizione', value: 'description', width: '100%' },
				{ text: '', value: 'actions', sortable: false },
			],
			edit: {
				dialog: false,
				item: {
					id: null,
					parent_id: null,
					title: '',
					description: '',
				},
			},
			remove: {
				dialog: false,
			},
		}
	},

	computed: {
		...mapGetters({
			categories: 'getCategoriesList',
		}),
	},

	methods: {
		openEditDialog(item) {
			this.edit.item = item
			this.edit.dialog = true
		},
		closeEditDialog() {
			this.edit.dialog = false
		},
		openRemoveDialog(item) {
			this.remove.dialog = true
		},
		closeRemoveDialog() {
			this.remove.dialog = false
		},
	},
}
</script>
